import { Component, Input } from '@angular/core';
import { FILE_ICON_MAPPINGS } from '@careapp-group/core';

const KNOWN_FILES = [
  'aac',
  'ai',
  'aiff',
  'avi',
  'bmp',
  'css',
  'csv',
  'dat',
  'dmg',
  'doc',
  'dotx',
  'dwg',
  'dxf',
  'eps',
  'exe',
  'flv',
  'gif',
  'html',
  'ics',
  'iso',
  'java',
  'jpg',
  'js',
  'key',
  'mid',
  'mp3',
  'mp4',
  'mov',
  'mpg',
  'odf',
  'ods',
  'odt',
  'otp',
  'ots',
  'ott',
  'pdf',
  'png',
  'ppt',
  'psd',
  'qt',
  'rar',
  'rtf',
  'tga',
  'tgz',
  'tiff',
  'txt',
  'wav',
  'xls',
  'xlsx',
  'xml',
  'yml',
  'zip',
];

@Component({
    selector: 'ca-file-icon',
    templateUrl: './file-icon.component.html',
    styleUrls: ['./file-icon.component.scss'],
    standalone: false
})
export class FileIconComponent {
  public extension = '';
  public type = '';
  public subtype = '';

  private _mimeType: string;

  public get mimeType(): string {
    return this._mimeType;
  }

  @Input()
  public set mimeType(value: string) {
    this._mimeType = value;
    const parts = this.mimeTypeToParts(value);
    this.extension = this.extensionForMimeType(value);
    this.type = parts.type;
    this.subtype = parts.subtype;

    if (this.extension == '_blank') {
      this.extension = '';
    }
  }

  mimeTypeToParts(mimeType: string): { type: string; subtype: string } {
    const type = mimeType.slice(0, mimeType.indexOf('/')).trim();
    const subtype = mimeType.slice(mimeType.indexOf('/') + 1).trim();
    return { type, subtype };
  }

  // A legacy file icon URL (used as a backup for failed video thumbnails).
  // Do not use.
  static iconUrlForMimeType(mimeType: string) {
    const cmp = new FileIconComponent();
    return `assets/images/file-icons/${cmp.extensionForMimeType(mimeType)}.png`;
  }

  extensionForMimeType(mimeType: string): string {
    if (!mimeType) {
      return '_blank';
    }
    const { subtype } = this.mimeTypeToParts(mimeType);
    if (KNOWN_FILES.indexOf(subtype) >= 0) {
      return KNOWN_FILES[KNOWN_FILES.indexOf(subtype)];
    }
    if (FILE_ICON_MAPPINGS[mimeType]) {
      return FILE_ICON_MAPPINGS[mimeType];
    }
    return '_blank';
  }
}
